import { qportalApi } from './qportal-api';
const assignPackage = (Package) => {
    return qportalApi.post(`Packages`, Package);
};
const getAllPackages = () => {
    return qportalApi.get(`Packages`);
};
const getFilteredInvoicePackages = () => {
    return qportalApi.get(`Packages/GetFilteredInvoicePackages`);
};
const PackageApi = {
    assignPackage,
    getAllPackages,
    getFilteredInvoicePackages
};
export default PackageApi;
